@if (state().status !== 'none') {
<div class="supply-drop-widget">
  @if (state().status === 'running') {
  <div class="join">
    <img class="drop-icon" [src]="state().supplyDropInformation?.image" alt="Supply Drop" />
    <div class="name-wrapper">
      <div class="drop-name">Supply Drop</div>
      <div class="drop-name drop-name--highlight">{{ state().supplyDropInformation?.skin_name }}</div>
    </div>
    <div class="drop-info">
      <span class="countdown">{{ countdownLabel() }}</span>
      <span class="separator"></span>
      <div class="drop-players">{{ state().players }} joined</div>
    </div>
    <button type="button" class="drop-join button green" (click)="openCaptchaModal()">Join</button>
  </div>
  } @else {
  <div class="roll-container">
    @if (rollPhase() === 'avatars') {
    <div class="roll-wrapper" [style.transform]="reelTransform()">
      @for (avatar of avatarReel(); track $index) {
      <div class="item avatar" [class.win]="$index === winIndex">
        <img [src]="avatar" loading="lazy" width="28" height="28" alt="supply drop participant avatar" />
        @if ($index === winIndex) {
        <div class="item-extra">
          <div class="item-name">{{ state().supplyDrop?.winnername }}</div>
        </div>
        }
      </div>
      }
    </div>
    }
    @if (rollPhase() === 'skins') {
    <div class="roll-wrapper" [style.transform]="reelTransform()">
      @for (skin of skinReel(); track $index) {
      <div class="item skin" [class.win]="$index === winIndex" [style.--skin-color]="skin.color">
        <img [src]="skin.image" loading="lazy" width="28" height="28" [alt]="skin.name" />
        @if ($index === winIndex) {
        <div class="item-extra">
          <div class="item-name">{{ skin.name }}</div>
          <app-currency [size]="10" [value]="skin.price"></app-currency>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  }
</div>
}
